import LocalStorage from '../local_data';
import Event from './Event';

class SaveOrderInfo extends Event {
    eventName = 'oms_saveOrderInfo';

    constructor() {
        super();
        this.add();
    }

    /**
     * @override
     * 
     * Event Function for Save Order Details
     * 
     * @param {string} data.user_info -  user info
     * @param {string} data.delivery_info -  delivery info
     * @param {string} data.payment_info -  payment info
     * @param {string} data.instruction -  special instruction
     * @param {string} data.more_info -  custom field data
     * @return void
     *  
     */
    eventFunction(data) {

        let clientId = data.client_id;
        let thisObj = this;
        let requestId = (data.request_id) ? data.request_id : '';
        let action = (data.action) ? data.action : '';

        
        if (clientId) {
            let orderDetails = new LocalStorage.OrderDetails(clientId);
            orderDetails.setData(data);

            thisObj.onSuccessEvent({
                "auth_type": "public",//? 
                "data": data,
                "data_type": "local", //
                "success" : true,//
                "message" : ""//
            }, {
                'action' : action, 
                'request_id' : requestId 
            });

        } else {
            //fire error event
            thisObj.onErrorEvent({ "message": "client_id is required", "status": 422 }, {'action' : action, 'request_id' : requestId });
        }
    }
}

export default SaveOrderInfo;